<template>
  <div>
    <DynamicComponent edc-id="polaris-shift-management" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'ShiftManagement',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
